namespace $.$$ {

	$mol_style_define( $shm_hitalama_profile_page, {

		Login_tools: {
			display: 'flex',
			gap: $mol_gap.text,
			padding: $mol_gap.block,
		},

		Save: {
			'[disabled]': {
				true: {
					background: {
						color: $mol_theme.line,
					},
					color: $mol_theme.shade,
				},
			},
		},

		Message: {
			color: 'red',
		},

	} )

}
